import { useState, useEffect } from "react";

import { useUser } from "utils/hooks";
import API from "utils/api";

export default function useProduct(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchProduct() {
      setLoading(true);
      const { response, data } = await API.fetchProduct(token, id);

      if (response.ok) {
        setResult(data);
        setError(null);
      } else {
        setError({ status: response.status, ...data });
      }

      setLoading(false);
    }

    fetchProduct();
  }, [id]);

  return {
    loading,
    error,
    product: result,
  };
}
